import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 40"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"a\"><path d=\"M30 15h30v15zm0 0v15H0zm0 0H0V0zm0 0V0h30z\"></path></clipPath></defs><path d=\"M0 0h60v40H0z\" style=\"fill:#00247d;\"></path><g style=\"stroke:#fff;stroke-width:6.93225527;fill:none;\"><path d=\"m0 0 60 40m0-40L0 40\"></path><path d=\"m0 0 60 30m0-30L0 30\" clip-path=\"url(#a)\" style=\"stroke:#cf142b;stroke-width:4;\" transform=\"scale(1 1.33333)\"></path><path d=\"M30 0v40M0 20h60\" style=\"stroke-width:11.55375878;\"></path><path d=\"M30 0v40M0 20h60\" style=\"stroke:#cf142b;\"></path></g>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }